import { NewClientContactGetters } from './new-client-contact.keys';
import format from 'date-fns/format';

export const getInitialState = () => {
  return {
    newClientContact: {
      created_at: format(new Date(), 'YYYY-MM-DD'),
      first_name: '',
      last_name: '',
      preferred_name: '',
      clients: [],
      email: '',
      email_alt: '',
      address: {
        line1: '',
        line2: '',
        city: '',
        province_abbr: null,
        postal_code: ''
      },
      user: {
        is_active: true,
        first_name: '',
        last_name: '',
        preferred_name: '',
        email: '',
        email_alt: '',
        phone1: '',
        phone1_type: null,
        phone2: '',
        phone2_type: null,
        phone3: '',
        phone3_type: null
      }
    }
  };
};

export const newClientContactStore = {
  state: getInitialState,
  getters: {
    [NewClientContactGetters.NewClientContact]: state => {
      return state.newClientContact;
    }
  }
};
